import React, { useState } from 'react'
import { firestore } from '../../../../firebase';

function AddPlayer({id}) {

    const [name, setName] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("")

    async function addPlayerHandler(e) {
        e.preventDefault()
        try {
            const playerRef = firestore.collection("hostcup").doc(id).collection("players")
            const data = {
                name
            }
            playerRef.add(data);
            setMessage("Lagt til!")
            setName("")
        } catch (error) {
            console.log(error)
            setError("Kunne ikke legge til spiller", error);
        }

    }

    return (
        <form onSubmit={addPlayerHandler}>
            <input className="form-control mb-2" placeholder="Navn" value={name} onChange={e => setName(e.target.value)} />
            {error && <div className="alert alert-danger">{error} ID: {id}</div>}
            {message && <div className="alert alert-success">{message} <span onClick={() => setMessage("")} className="float-right">Lukk</span></div>}
            <button className="btn btn-success">Legg til spiller</button>
        </form>
    )

}
export default AddPlayer